import scheduledTasksService from './scheduledTasksService'

export default scheduledTasksService



// WEBPACK FOOTER //
// ../src/services/scheduledTasksService/index.js